import React from 'react'
import { Box, Typography } from '@mui/material'
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined'

interface EmptyStateProps {
  icon?: React.ReactNode
  title?: string
  subtitle?: string
  action?: React.ReactNode
}

const EmptyState = ({
  icon = <InboxOutlinedIcon sx={{ fontSize: 48, color: 'text.secondary', opacity: 0.5 }} />,
  title = 'No results found',
  subtitle,
  action,
}: EmptyStateProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      px: 3,
    }}
  >
    {icon}
    <Typography
      sx={{
        fontSize: '16px',
        fontWeight: 600,
        color: 'text.primary',
        mb: 0.5,
        mt: 2,
      }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography
        sx={{
          fontSize: '14px',
          color: 'text.secondary',
        }}
      >
        {subtitle}
      </Typography>
    )}
    {action && <Box sx={{ mt: 2 }}>{action}</Box>}
  </Box>
)

export default EmptyState
